package team.platforma.aicombo.activity.main.component.settings.fragment

import team.platforma.extra_nav.component.fragment_component.Fragment

object SettingsFragment : Fragment(
    route = "settings_fragment",
    fragmentBox = { componentNavigator, fragmentNavigator, paddingValues ->  }
)